export const PLATFORM_RULES_URL = 'https://support.spotify.com/article/platform-rules/';
export const CONTENT_ACTIONS_URL = 'https://support.spotify.com/uk/article/content-actions/';

export const CONTENTREPORTINGAPI_URL = process.env.REACT_APP_CONTENTREPORTING_API_URL || '';
export const URI_PARAM = 'uri';
